<template>
  <ag-card-container
    :title="$t('multitask.title.main')"
    fluid
  >
    <v-row>
      <v-col
        cols="12"
        sm="6"
        md="4"
        offset-sm="3"
        offset-md="4"
      >
        <settings-form
          v-if="value"
          :value="value"
          :loading="loadingUpdate"
          @input="update"
        />
      </v-col>
    </v-row>
  </ag-card-container>
</template>

<script>
import AgCardContainer from 'src/components/common/AgCardContainer'
import Repositories from 'src/repositories'
import { mapActions } from 'vuex'
import SettingsForm from '../components/SettingsForm'

export default {
  name: 'MultitaskContainer',
  components: {
    AgCardContainer,
    SettingsForm,
  },
  data: () => ({
    value: null,
    loading: false,
    loadingUpdate: false,
  }),
  watch: {
    $route: {
      immediate: true,
      handler () {
        this.fetchData()
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    async fetchData () {
      this.loading = true
      this.value = await Repositories.multiTask.settings.get()
      this.loading = false
    },
    async update (value) {
      try {
        this.loadingUpdate = true
        this.value = await Repositories.multiTask.settings.patch(value)
        const notification = this.$tc('multitask.fields.success.settingsUpdated')
        this.showSuccessNotification(notification)
      }
      catch (error) {
        const notification = Repositories.multiTask.settings.parseErrorMessage(error)
        this.showErrorNotification(notification)
      }
      finally {
        this.loadingUpdate = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.v-tab {
  &::before {
    opacity: 0.4 !important;
  }

  &:hover::before {
    opacity: 0.1 !important;
  }
}

.v-tab--active {
  &::before {
    opacity: 0.1 !important;
  }

  &:hover::before {
    opacity: 0.1 !important;
  }
}
</style>
